import ActiveMatch from "./pages/ActiveMatch";
import AddMatch from "./pages/AddMatch";
import AprofitCasino from "./pages/AprofitCasino";
import AprofitDownline from "./pages/AprofitDownline";
import Adownlinesportspl from "./pages/Adownlinesportspl";
import AprofitByDownline from "./pages/AprofitByDownline";
import AprofitPlayer from "./pages/AprofitPlayer";
import AprofitMarket from "./pages/AprofitMarket";
import ACdownlinesportspl from "./pages/ACdownlinesportspl";
import ACasinoprofitAndLossDownlineNew from "./pages/ACasinoprofitAndLossDownlineNew";
import ICasinoprofitAndLossDownlineNew from "./pages/ICasinoprofitAndLossDownlineNew";
import Banking from "./pages/Banking/Banking";
import BetCount from "./pages/BetCount";
import BetList from "./pages/BetList";
import BetListLive from "./pages/BetListLive";
import UserBetListLive from "./pages/UserBetListLive/UserBetListLive";
import BettingHistory from "./pages/BettingHistory/BettingHistory";
import BettingProfitLoss from "./pages/BettingProfitLoss/BettingProfitLoss";
import BlockMarket from "./pages/BlockMarket";
import DefaultSetting from "./pages/DefaultSetting";
import FancyResult from "./pages/FancyResult";
import GeneralSetting from "./pages/Generalsetting";
import Home from "./pages/Home";
import HyperMessage from "./pages/HyperMessage";
import ImportantMessage from "./pages/ImportantMessage";
import InActiveMatch from "./pages/InActiveMatch";
import InactiveUsers from "./pages/InactiveUsers";
import LiveMatchBet from "./pages/LiveMatchBet";
import ManageLinks from "./pages/ManageLinks";
import Manupulation from "./pages/Manupulation";
import MarketResult from "./pages/MarketResult";
import TossResult from "./pages/TossResult";
import MyAccountStatement from "./pages/MyAccount/MyAccountStatement";
import MyAccountSummary from "./pages/MyAccount/MyAccountSummary";
import MyActivityLog from "./pages/MyAccount/MyActivityLog";
import MyProfile from "./pages/MyAccount/MyProfile";
import TransactionLogs from "./pages/MyAccount/TransactionLogs";
import PlayerBalance from "./pages/PlayerBalance";
import PreMatch from "./pages/PreMatch";
import RejectedBets from "./pages/RejectedBets/RejectedBets";
import ViewFancyDetails from "./pages/RejectedBets/ViewFancyDetails";
import Result from "./pages/Result";
import RiskManagement from "./pages/RiskManagement/RiskManagement";
import SearchMatch from "./pages/SearchMatch";
import SearchUser from "./pages/SearchUser";
import SetBookMarker from "./pages/SetBookMarker";
import SetLimit from "./pages/SetLimit";
import SportSetting from "./pages/SportSetting";
import StatementByUser from "./pages/StatementByUser";
import SurveillanceSetting from "./pages/SurveillanceSetting";
import SuspendedResult from "./pages/SuspendedResult";
import UserMessage from "./pages/UserMessage";
import AccountSummary from "./pages/Users/AccountSummary";
import ActivityLog from "./pages/Users/ActivityLog";
import TransactionHistory from "./pages/Users/TransactionHistory";
import TransactionHistory2 from "./pages/Users/TransactionHistory2";
import ViewCasinoBetDialog from "./pages/InternationalCasionBets";
import ViewAECasionBets from "./pages/AECasionBets";
import WebsiteSetting from "./pages/WebsiteSetting";
import BetLockUser from "./pages/BetLockUser";
import Statements from "./pages/Statements";
import SuspendedMarketResult from "./pages/SuspendedMarketResult";
import SuspendedFancyResult from "./pages/SuspendedFancyResult";
import viewBets from "./pages/viewBets";
import updateFancyStatus from "./pages/updateFancyStatus";
import UserProfitLoss from "./pages/UserProfitLoss";
import MatchProfitLoss from "./pages/MatchProfitLoss";
import ShowBetsCR from "./pages/ShowBetsCR";
import DisplayMatchBet from "./pages/DisplayMatchBet";
import DisplaySessionBet from "./pages/DisplaySessionBet";
import AddWebsite from "./pages/AddWebsite";
import CurrentBets from "./pages/CurrentBets";
import DefaultAgent from "./pages/DefaultAgent";
import WalletWithdrwal from "./pages/WalletWithdrwal";
import WalletDeposit from "./pages/WalletDeposit";
import Dashboard from "./pages/Dashboard";
import Banks from "./pages/Banking/Banks";
import DepositHistory from "./pages/DepositHistory";
import WithdrawalHistory from "./pages/WithdrawalHistory";
import BannerList from "./pages/Banner/List";
import ComissionReport from "./pages/ComissionReport";
import PromotionalOffer from "./pages/PromotionalOffer";
import CSetting from "./pages/CSetting";
import NagadSms from "./pages/NagadSms";
import Sms from "./pages/Sms";
import RocketSms from "./pages/RocketSms";
import WithdrwaRequest from "./pages/WithdrawRequest";
import AgentWithdrawHistory from "./pages/AgentWithdrawHistory";
import AgentRefrralList from "./pages/AgentRefrralList";
import AffilateList from "./pages/Users/AffilateList";
import MatchedAll from "./pages/RiskManagement/MatchedAll";
import SportAnalytics from "./pages/SportAnalytics/SportAnalytics";
import ReportType from "./pages/Report/ReportType";
import Index from "./CustomerSupport/Index";
import SportSettingNew from "./pages/SportSettingNew";
import CasinoNew from "./pages/CasinNew";
import GameControl from "./pages/GameControl";
import Settlement from "./pages/Settlement/Settlement";
import AllAprofitByDownline from "./pages/AllAprofitByDownline";
import MatchWiseProfitLoss from "./pages/MatchWiseProfitLoss";
import MatchBetDetails from "./pages/MatchBetDetails";
import Turnover from "./pages/Users/Turnover";

// import AuthContext from "./context/AuthContext";
// let {user} = useContext(AuthContext);
// console.log('user',user);
export const routes = [
  {
    path: "/",
    Component: Home,
    permission: [],
  },
  {
    path: "/dashboard",
    Component: Dashboard,
    permission: [],
  },
  {
    path: "/:id/:user_type",
    Component: Home,
    permission: [],
  },
  {
    path: "/account-summary",
    Component: AccountSummary,
    permission: [],
  },
  {
    path: "/customer-support",
    Component: Index,
    permission: [],
  },
  {
    path: "/match-details/:eventId/:marketId",
    Component: SportAnalytics,
    permission: [],
  },
  {
    path: "/betting-history",
    Component: BettingHistory,
    permission: [],
  },  {
    path: "/settlement",
    Component: Settlement,
    permission: [],
  },
  // {
  //   path: "/sms",
  //   Component: Sms,
  //   permission: ["owner", "super_admin"],
  // },
  {
    path: "/sms",
    Component: Sms,
    permission: ["owner", "sub_admin", "agent"],
  },
  {
    path: "/nagad-sms",
    Component: NagadSms,
    permission: ["owner", "sub_admin", "agent"],
  },
  {
    path: "/rocket-sms",
    Component: RocketSms,
    permission: ["owner", "sub_admin", "agent"],
  },
  {
    path: "/TransactionHistory",
    Component: TransactionHistory,
    permission: [],
  },
  {
    path: "/activitylog",
    Component: ActivityLog,
    permission: [],
  },
  {
    path: "/betting-profit-loss",
    Component: BettingProfitLoss,
    permission: [],
  },
  {
    path: "/report/:type",
    Component: ReportType,
    permission: [],
  },
  {
    path: "/account-summary/:id/:type/:page",
    Component: AccountSummary,
    permission: [],
  },
  {
    path: "/account-summary/:id/:type",
    Component: AccountSummary,
    permission: [],
  },
  {
    path: "/betting-history/:id/:type",
    Component: BettingHistory,
    permission: [],
  },
  {
    path: "/current-bets",
    Component: UserBetListLive,
    permission: [],
  },
  {
    path: "/current-bets/:id/:type",
    Component: UserBetListLive,
    permission: [],
  },

  {
    path: "/transaction-history/:id",
    Component: TransactionHistory,
    permission: [],
  },
  {
    path: "/transaction-history/:id/:type",
    Component: TransactionHistory,
    permission: [],
  },
  {
    path: "/currentBets/:id/:type",
    Component: CurrentBets,
    permission: [],
  },
  {
    path: "/banks",
    Component: Banks,
    permission: [],
  },
  {
    path: "/transaction-history/:id/:type",
    Component: TransactionHistory,
    permission: [],
  },
  {
    path: "/transaction-history-2/:id/:type",
    Component: TransactionHistory2,
    permission: [],
  },
  {
    path: "/transaction-history-2/:id",
    Component: TransactionHistory2,
    permission: [],
  },
  {
    path: "/matchedAll",
    Component: MatchedAll,
    permission: [],
  },
  {
    path: "/AECasionBets/:id/:type",
    Component: ViewAECasionBets,
    permission: [],
  },
  {
    path: "/InternationalCasionBets/:id/:type",
    Component: ViewCasinoBetDialog,
    permission: [],
  },
  {
    path: "/activity-log/:id",
    Component: ActivityLog,
    permission: [],
  },
  {
    path: "/activity-log/:id/:type",
    Component: ActivityLog,
    permission: [],
  },
  {
    path: "/betting-profit-loss/:id/:type",
    Component: BettingProfitLoss,
    permission: [],
  },

  {
    path: "/my-account-summary",
    Component: MyAccountSummary,
    permission: [],
  },
  {
    path: "/my-account-statement",
    Component: MyAccountStatement,
    permission: [],
  },
  {
    path: "/my-profile",
    Component: MyProfile,
    permission: [],
  },
  {
    path: "/deposit-history",
    Component: DepositHistory,
    permission: [],
  },
  {
    path: "/withdrawal-history",
    Component: WithdrawalHistory,
    permission: [],
  },
  {
    path: "/agent-withdraw-history",
    Component: AgentWithdrawHistory,
    permission: ["owner", "sub_admin"],
  },
  {
    path: "/my-activity-log",
    Component: MyActivityLog,
    permission: [],
  },
  {
    path: "/transaction-logs",
    Component: TransactionLogs,
    permission: [],
  },
  {
    path: "/transaction-logs/:id",
    Component: TransactionLogs,
    permission: [],
  },

  {
    path: "/statements/:id",
    Component: Statements,
    permission: [],
  },
  {
    path: "/Betlist",
    Component: BetList,
    permission: [],
  },
  {
    path: "/BetListLive",
    Component: BetListLive,
    permission: [],
  },
  {
    path: "/AprofitDownline",
    Component: AprofitDownline,
    permission: [],
  },

  {
    path: "/AprofitByDownline",
    Component: AprofitByDownline,
    permission: [],
  },

  {
    path: "/AprofitDownline/:id/:user_type",
    Component: AprofitDownline,
    permission: [],
  },
  {
    path: "/AprofitByDownline/:id/:user_type",
    Component: AprofitByDownline,
    permission: [],
  },
  {
    path: "/AprofitPlayer",
    Component: AprofitPlayer,
    permission: [],
  },
  {
    path: "/AprofitMarket",
    Component: AprofitMarket,
    permission: [],
  },
  {
    path: "/AprofitCasino",
    Component: AprofitCasino,
    permission: [],
  },
  {
    path: "/Adownlinesportspl",
    Component: Adownlinesportspl,
    permission: [],
  },
  {
    path: "/ACdownlinesportspl",
    Component: ACdownlinesportspl,
    permission: [],
  },
  {
    path: "/ACdownlinesportspl/:id/:user_type",
    Component: ACdownlinesportspl,
    permission: [],
  },
  {
    path: "/ACasinoprofitAndLossDownlineNew",
    Component: ACasinoprofitAndLossDownlineNew,
    permission: [],
  },
  {
    path: "/ACasinoprofitAndLossDownlineNew/:id/:user_type",
    Component: ACasinoprofitAndLossDownlineNew,
    permission: [],
  },
  {
    path: "/ICasinoprofitAndLossDownlineNew",
    Component: ICasinoprofitAndLossDownlineNew,
    permission: [],
  },
  {
    path: "/ICasinoprofitAndLossDownlineNew/:id/:user_type",
    Component: ICasinoprofitAndLossDownlineNew,
    permission: [],
  },
  {
    path: "/Withdraw_request",
    Component: WithdrwaRequest,
    permission: ["owner", "sub_admin"],
  },
  {
    path: "/commission-report",
    Component: ComissionReport,
    permission: ["owner", "super_agent", "agent", "sub_admin"],
  },
  {
    path: "/StatementByUser",
    Component: StatementByUser,
    permission: [],
  },
  {
    path: "/RiskManagement",
    Component: RiskManagement,
    permission: [],
  },
  {
    path: "/banking",
    Component: Banking,
    permission: [],
  },
  {
    path: "/SetBookMarker",
    Component: SetBookMarker,
    permission: ["owner", "super_admin"],
  },
  {
    path: "/agent-referral-list",
    Component: AffilateList,
    permission: ["agent"],
  },
  {
    path: "/block-market",
    Component: BlockMarket,
    permission: [], //"owner", "super_admin"
  },
  {
    path: "/sport-setting",
    Component: SportSetting,
    permission: ["owner", "super_admin"],
  },
    {
    path: "/casino-control/:id/:type",
   Component: CasinoNew,
    permission: [],
  },
    {
    path: "/game-control/:id/:type",
    Component: GameControl,
    permission: [],
  },
  {
    path: "/sport-setting/:id/:type",
    Component: SportSettingNew,
    permission: [],
  },
  {
    path: "/SetLimit/:id/:type",
    Component: SetLimit,
    permission: ["owner", "super_admin"],
  },
  {
    path: "/Manupulation",
    Component: Manupulation,
    permission: ["owner", "super_admin"],
  },

  {
    path: "/wallet-withdrawal",
    Component: WalletWithdrwal,
    permission: ["owner", "sub_admin", "agent"],
  },
  {
    path: "/wallet-deposit",
    Component: WalletDeposit,
    permission: ["owner", "sub_admin", "agent"],
  },
  {
    path: "/add-match",
    Component: AddMatch,
    permission: ["owner"],
  },
  {
    path: "/general-setting",
    Component: GeneralSetting,
    permission: [], 
  },
  {
    path: "/manage-links",
    Component: ManageLinks,
    permission: ["owner", "agent", "sub_admin","sub_owner"],
  },
  {
    path: "/add-website",
    Component: AddWebsite,
    permission: ["owner", "super_admin","sub_owner"],
  },
  {
    path: "/FancyResult",
    Component: FancyResult,
    permission: [],
  },
  {
    path: "/MarketResult",
    Component: MarketResult,
    permission: [],
  },
  {
    path: "/TossResult",
    Component: TossResult,
    permission: [],
  },
  {
    path: "/banner-list",
    Component: BannerList,
    permission: [],
  },
  {
    path: "/LiveMatchBet",
    Component: LiveMatchBet,
    permission: ["owner", "super_admin"],
  },
  {
    path: "/defaultAgent",
    Component: DefaultAgent,
    permission: ["owner", "super_admin", "admin", "sub_admin"],
  },
  {
    path: "/promotionalOffer",
    Component: PromotionalOffer,
    permission: ["owner", "sub_admin", "agent"],
  },

  {
    path: "/BetCount",
    Component: BetCount,
    permission: ["owner", "super_admin"],
  },
  {
    path: "/PreMatch",
    Component: PreMatch,
    permission: ["owner", "super_admin"],
  },
  {
    path: "/MatchProfitLoss/:id",
    Component: MatchProfitLoss,
    permission: ["owner", "super_admin"],
  },
  {
    path: "/ShowBetsCR/:eventId/:userId",
    Component: ShowBetsCR,
    permission: ["owner", "super_admin"],
  },
  {
    path: "/DisplayMatchBet/:eventId",
    Component: DisplayMatchBet,
    permission: ["owner", "super_admin"],
  },
  {
    path: "/DisplaySessionBet/:eventId",
    Component: DisplaySessionBet,
    permission: ["owner", "super_admin"],
  },

  {
    path: "/SearchMatch",
    Component: SearchMatch,
    permission: ["owner", "super_admin"],
  },
  {
    path: "/PlayerBalance",
    Component: PlayerBalance,
    permission: [], //"owner", "super_admin"
  },

  {
    path: "/UserProfitLoss",
    Component: UserProfitLoss,
    permission: ["owner", "super_admin"],
  },

  {
    path: "/result",
    Component: Result,
    permission: [],
  },
  {
    path: "/WebsiteSetting",
    Component: WebsiteSetting,
    permission: ["owner", "super_admin", "agent","sub_owner"],
  },
  {
    path: "/rejected-bets",
    Component: RejectedBets,
    permission: ["owner", "super_admin"],
  },
  {
    path: "/fancy-details/:id",
    Component: ViewFancyDetails,
    permission: ["owner", "super_admin"],
  },
  {
    path: "/searchuser",
    Component: SearchUser,
    permission: [], //"owner", "super_admin"
  },
  {
    path: "/defaultsetting",
    Component: DefaultSetting,
    permission: ["owner", "super_admin", "sub_owner",],
  },
  {
    path: "/SurveillanceSetting",
    Component: SurveillanceSetting,
    permission: [], //"owner", "super_admin"
  },
  {
    path: "/active-match",
    Component: ActiveMatch,
    permission: [], //"owner", "super_admin"
  },
  {
    path: "/in-active-match",
    Component: InActiveMatch,
    permission: [], //"owner", "super_admin"
  },
  {
    path: "/SuspendedResult",
    Component: SuspendedResult,
    permission: [], //"owner", "super_admin"
  },
  {
    path: "/user-message",
    Component: UserMessage,
    permission: ["owner", "super_admin", "sub_admin", "agent"],
  },
  {
    path: "/hyper-message",
    Component: HyperMessage,
    permission: ["owner"],
  },
  {
    path: "/importantmessage",
    Component: ImportantMessage,
    permission: ["owner"],
  },
  {
    path: "/inactive-users",
    Component: InactiveUsers,
    permission: [], //"owner", "super_admin"
  },
  {
    path: "/BetLockUser",
    Component: BetLockUser,
    permission: [], //"owner", "super_admin"
  },
  {
    path: "/SuspendedMarketResult",
    Component: SuspendedMarketResult,
    permission: [], //"owner", "super_admin"
  },
  {
    path: "/SuspendedFancyResult",
    Component: SuspendedFancyResult,
    permission: [], //"owner", "super_admin"
  },
  {
    path: "/viewBets/:eventId",
    Component: viewBets,
    permission: [], //"owner", "super_admin"
  },
  {
    path: "/updateFancyStatus",
    Component: updateFancyStatus,
    permission: [], //"owner", "super_admin"
  },
  {
    path: "/Commission_setting",
    Component: CSetting,
    permission: [],
  },
  {
    path: "/AllAprofitByDownline",
    Component: AllAprofitByDownline,
    permission: [],
  },
  {
    path: "/AllAprofitByDownline/:id/:user_type",
    Component: AllAprofitByDownline,
    permission: [],
  },
  {
    path: "/MatchWiseProfitLoss",
    Component: MatchWiseProfitLoss,
    permission: [],
     
  },
  {
    path: "/MatchBetDetails/:betFaireType/:eventId/:marketId/:selectionId",
    Component: MatchBetDetails,
    permission: [],
     
  },
  {
    path: "/turnover/:id/:type",
    Component: Turnover,
    permission: [],
  },
];
